// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".solid-hr hr[data-v-53751510] {\n  border-top: 1px solid var(--v-black-base) !important;\n}", ""]);
// Exports
module.exports = exports;
